<template>
  <div id="health_check" v-if="hcData">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8 ">
          <h1 class="health-check-title">{{ hcData.title }}</h1>
        </div>
      </div>
    </div>

    <div class="health-check__container " id="health_check__container">
      <div class="row" v-if="!isFinished">
        <div class="container-fluid">
          <div class="col-12 offset-lg-2 col-lg-8">
            <HealthCheckIntro />
            <SurveyIntro />
          </div>
        </div>
      </div>

      <div class="questions">
        <div class=" container-fluid">
          <div class="row">
            <div class="col-12 offset-lg-2 col-lg-8">
              <Questions />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "./store";
import HealthCheckIntro from "./components/HealthCheckIntro";
import SurveyIntro from "./components/SurveyIntro";
import Questions from "./components/Questions";

export default {
  name: "HealthCheck",
  store: store,
  components: { Questions, SurveyIntro, HealthCheckIntro },
  mounted() {
    let cacheBuster = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(0, 5);
    axios
      .get(
        "/wp-json/acf/v3/pages/" + this.currentPageID + "?ver=" + cacheBuster
      )
      .then(response => {
        store.commit("hcData", response.data.acf);
      });
  },

  computed: {
    /**
     * Get the current WP page ID
     * @returns {string}
     */
    currentPageID() {
      let pageId = null;
      let bodyClasses = document.querySelector("body").classList;
      bodyClasses.forEach(className => {
        if (className.indexOf("page-id-") > -1) {
          pageId = className.substr(8);
        }
      });
      return pageId;
    },
    hcData() {
      return store.getters.hcData;
    },
    currentQuestion() {
      return store.getters.currentQuestion;
    },
    currentSection() {
      return store.getters.currentSection;
    },
    isFinished() {
      return store.getters.isFinished;
    }
  },
  methods: {
    showNextQuestion() {
      store.commit("goToNextQuestion");
    }
  }
};
</script>
<style lang="scss">
html,
body {
  /*overflow: hidden;*/
}

body {
  padding-top: 64px;
}

#health_check {
  /*margin-top: 220px;*/
  position: relative;
  font-size: 24px;
  line-height: 30px;

  @media (max-width: 767px) {
    font-size: 15px;
    line-height: 21px;
  }

  p {
  }
}

.health-check {
  &-button {
    background-color: #0000ff;
    color: white;
    padding: 11px 20px;
    font-size: 15px;
    letter-spacing: -0.38;
    line-height: 16px;
    font-weight: 600;
    border: 0;
    cursor: pointer;
    border-radius: 2px;
  }

  &__container {
    height: calc(100vh);
    overflow-x: hidden;
    overflow-y: hidden;
  }
}

.health-check-title {
  text-align: center;
  width: 100%;
  padding: 44px 0 0;
  font-weight: 600;
  font-size: 26px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 767px) {
    font-size: 21px;
    line-height: 25px;
    width: 200px;
    margin: 0 auto;
  }

  &:after {
    content: "";
    align-self: baseline;
    margin: 15px auto 0;
    width: 31px;
    height: 2px;
    background-color: #22252a;
  }
}

.questions {
  $height: 330px;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) $height,
    rgba(0, 0, 255, 1) $height,
    rgba(0, 0, 255, 1) 100%
  );

  @media (max-width: 767px) {
    $height: calc(100vh - 360px);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0) $height,
      rgba(0, 0, 255, 1) $height,
      rgba(0, 0, 255, 1) 100%
    );
  }
}
</style>
